// extracted by mini-css-extract-plugin
export var closeButton = "_g9-1";
export var closeX = "_g9-3";
export var container = "_g9-0";
export var image = "_g9-2";